import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

@Injectable()
export class CustomOverlayContainer extends OverlayContainer {
  protected override _createContainer(): void {
    const container = document.createElement('div');
    container.classList.add('cdk-overlay-container');

    const customParent = document.getElementById('my-overlay-root');

    if (customParent) {
      // Make sure parent is positioned and sized
      if (getComputedStyle(customParent).position === 'static') {
        customParent.style.position = 'relative';
      }

      container.style.position = 'absolute';
      container.style.top = '0';
      container.style.left = '0';
      container.style.width = '100%';
      container.style.height = '100%';

      customParent.appendChild(container);
    } else {
      document.body.appendChild(container);
    }

    this._containerElement = container;
  }
}
